import { Group, Stack, Text } from "@mantine/core";

interface Props {
  before: Record<string, unknown>;
  after: Record<string, unknown>;
  labels: Record<string, string>;
}

export function DiffViewer({ before, after, labels }: Props) {
  // No "before" → this is a fresh activation, not a comparison. Render a clean
  // value summary (no "— →" arrows) instead of diffing against nothing.
  const hasBefore = Object.keys(before).length > 0;
  const isEmpty = (v: unknown) => v == null || v === "";

  const rows = Object.keys(labels)
    .map((key) => ({ key, b: before[key], a: after[key] }))
    // Drop rows that are empty on both sides (e.g. Тогтмол дүн for a % policy).
    .filter(({ b, a }) => !(isEmpty(b) && isEmpty(a)));

  return (
    <Stack gap="xs">
      {rows.map(({ key, b, a }) => {
        const changed = hasBefore && String(b ?? "") !== String(a ?? "");
        return (
          <Group key={key} justify="space-between" wrap="nowrap" gap="xl">
            <Text size="sm" c="dimmed">{labels[key]}</Text>
            {hasBefore ? (
              <Text size="sm" ta="right" c={changed ? "orange" : undefined} fw={changed ? 600 : 400}>
                {changed
                  ? `${isEmpty(b) ? "—" : String(b)} → ${isEmpty(a) ? "—" : String(a)}`
                  : (isEmpty(a) ? "—" : String(a))}
              </Text>
            ) : (
              <Text size="sm" ta="right" fw={500}>{isEmpty(a) ? "—" : String(a)}</Text>
            )}
          </Group>
        );
      })}
    </Stack>
  );
}
